module.exports = __webpack_public_path__ + "static/media/instituteForEconomicsAndPeace.a123aba7.png";